import {reportDetailType} from "../constanst/index";

import {reportDetailsAction} from "../actions/IReportDetailsAction";
import {ActionWithPayload} from '../types/ActionsType';
import {reportState} from "../types/reportDetailsType";
import {Exception} from "../types/exceptionType"; 

let error:Exception= {status:"", message:"", data:{}}

const initialState = {
    loading: false,
    report: {},
    error: error,
  };
  

const reportReducer = (state = initialState, action:ActionWithPayload<reportDetailsAction>):reportState =>{
    switch(action.type){
        case reportDetailType.FETCH_REPORTDETAILD_REQUEST:
            return {
                ...state,
                loading:true
            }
        
        case reportDetailType.FETCH_REPORTDETAIL_SUCCESS:
            return{
                loading:false,
                report:action.payload,
                error:error
            }
        case reportDetailType.FETCH_REPORTDETAIL_FAILURE:
            return{
                loading:false,
                report:{},
                error:action.payload
            }
        case reportDetailType.CLEAN_REPORTDETAIL:
            return initialState;
        default:
            return state;
    }
}

export default reportReducer;